"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Card, CardContent } from "@/shared/components/ui/card";
import { FEATURE_CARDS } from "../data/features";
import { Reveal } from "./shared/reveal";

export const FeaturesGrid = () => {
    const reduce = useReducedMotion();

    return (
        <section id="features" className="relative py-20 sm:py-28">
            <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                {/* Section heading. */}
                <Reveal className="mx-auto max-w-2xl text-center">
                    <span className="text-sm font-semibold uppercase tracking-widest text-zinc-500">
                        Features
                    </span>
                    <h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl">
                        One app for the whole operation
                    </h2>
                    <p className="mt-4 text-pretty text-muted-foreground">
                        From the front desk to the books — every part of running a gym,
                        built in and working together.
                    </p>
                </Reveal>

                {/* Each card slides up on its own as it scrolls into view.
                    Two compact columns on mobile so the list isn't a long stack. */}
                <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3">
                    {FEATURE_CARDS.map((feature, i) => (
                        <motion.div
                            key={feature.title}
                            initial={
                                reduce
                                    ? false
                                    : { opacity: 0, y: 90, filter: "blur(8px)" }
                            }
                            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{
                                duration: 0.75,
                                ease: [0.22, 1, 0.36, 1],
                                // Left-to-right cascade so each card in a row
                                // slides in one after another.
                                delay: (i % 3) * 0.12,
                            }}
                            className="h-full"
                        >
                            <Card className="group h-full border-border shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/10">
                                <CardContent>
                                    <span className="flex size-9 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground sm:size-11">
                                        <feature.icon className="size-4 sm:size-5" />
                                    </span>
                                    <h3 className="mt-3 text-sm font-semibold sm:mt-4 sm:text-base">
                                        {feature.title}
                                    </h3>
                                    <p className="mt-1 text-xs text-muted-foreground sm:mt-1.5 sm:text-sm">
                                        {feature.description}
                                    </p>
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
